module.exports = __webpack_public_path__ + "animoji5.533765f938.png";